
import React from "react";
import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
  icon?: React.ReactNode;
}

export function SectionHeader({
  title,
  subtitle,
  centered = false,
  className,
  icon
}: SectionHeaderProps) {
  return (
    <div className={cn("mb-10", centered && "text-center", className)}>
      <div className={cn("flex items-center gap-2 mb-4", centered && "justify-center")}>
        {icon && <div className="flex-shrink-0">{icon}</div>}
        <h2 className="section-title text-primary-DEFAULT">
          <span className="title-underline text-primary-DEFAULT">{title}</span>
        </h2>
      </div>
      {subtitle && <p className="">{subtitle}</p>}
    </div>
  );
}
